import Phaser from 'phaser';

/** Minimal boot: hand off to Preload. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    // Intentionally empty — PreloadScene loads game assets.
  }

  create(): void {
    this.scene.start('Preload');
  }
}
